import { useSyncExternalStore } from 'react';

export interface ToastData {
  id: string;
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

// Minimal module-level store so toast() can be called from anywhere (hooks,
// event handlers) and a single <Toaster /> renders them.
const MAX_TOASTS = 3;
let toasts: ToastData[] = [];
const listeners = new Set<() => void>();
let counter = 0;

const emit = (): void => listeners.forEach((l) => l());

export const toast = (data: Omit<ToastData, 'id'>): string => {
  const id = String(++counter);
  toasts = [{ ...data, id }, ...toasts].slice(0, MAX_TOASTS);
  emit();
  return id;
};

export const dismissToast = (id: string): void => {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useToasts = (): ToastData[] => useSyncExternalStore(subscribe, () => toasts);
